import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    snackbar: {
      show: false,
      message: '',
      color: 'success',
    },
    selectedOptionVista: 'alumno',
  }),

  getters: {
    // Ejemplo de getter; Pinia permite acceder a state directamente,
    // pero así sigues con la API “tipo Vuex”
    getSelectedOptionVista: state => state.selectedOptionVista,
  },

  actions: {
    triggerSnackbar({ message, color = 'success' }) {
      this.snackbar = { show: true, message, color };

      // autocierre
      setTimeout(() => {
        this.snackbar.show = false;
        this.snackbar.message = '';
      }, 5000);
    },

    setSelectedOptionVista(vista) {
      this.selectedOptionVista = vista;
    },
  },
});
